module.exports = __webpack_public_path__ + "static/media/galleryGT (11).30ec4dc5.jpg";